import { MARKETINGPLAYCONFIGURATION } from "../../constants/action-types";
const initialState = {
    marketingPlayLookup: [],
    touchpointsTemplateByPlayId: [],
    savedMarketingPlay: [],
    allPlayWithTouchpointsByClientId: [],
    allSchedulesByClientID: [],
    allTouchpointsByClientID: [],
    enableTouchpoint: [],
    loadedPlayTouchpointsByPlayId: null,
    loadedPlaysClientId: null,
    saveTouchpointScheduleMapping: [],
    updateTouchpointScheduleMapping: [],
    removeMarketingPlayById: [],
    allPlayTouchPointRevenueMappings: [],
    mappedScheduleByPlayId: []
}

const MarketingPlayConfigurationReducer = (state = initialState, action) => {
    switch (action.type) {

        case MARKETINGPLAYCONFIGURATION.LOAD_MARKETING_PLAY_LOOKUP: {
            return Object.assign({}, state, {
                marketingPlayLookup: action.payload
            });

        }
        case MARKETINGPLAYCONFIGURATION.GET_TOUCHPOINTS_TEMPLATE_BY_PLAY_ID: {
            return Object.assign({}, state, {
                touchpointsTemplateByPlayId: action.payload
            });

        }
        case MARKETINGPLAYCONFIGURATION.SAVE_MARKETING_PLAY_WITH_TOUCHPOINTS: {
            return Object.assign({}, state, {
                savedMarketingPlay: action.payload
            });

        }
        case MARKETINGPLAYCONFIGURATION.GET_ALL_PLAY_WITH_TOUCHPOINTS_BY_ClIENTID: {
            return Object.assign({}, state, {
                allPlayWithTouchpointsByClientId: action.payload
            });

        }
        case MARKETINGPLAYCONFIGURATION.GET_ALL_SCHEDULES_BY_ClIENTID: {
            return Object.assign({}, state, {
                allSchedulesByClientID: action.payload
            });

        }
        case MARKETINGPLAYCONFIGURATION.GET_ALL_TOUCHPOINTS_BY_ClIENTID: {
            return Object.assign({}, state, {
                allTouchpointsByClientID: action.payload
            });

        }
        case MARKETINGPLAYCONFIGURATION.ENABLE_TOUCHPOINT: {
            return Object.assign({}, state, {
                enableTouchpoint: action.payload
            });

        }
        case MARKETINGPLAYCONFIGURATION.GET_ALL_PLAY_WITH_TOUCHPOINTS_BY_PLAY_ID: {
            return Object.assign({}, state, {
                loadedPlayTouchpointsByPlayId: action.payload
            });

        }
        case MARKETINGPLAYCONFIGURATION.GET_ALL_PLAYS_CLIENT_ID: {
            return Object.assign({}, state, {
                loadedPlaysClientId: action.payload
            });

        }
        case MARKETINGPLAYCONFIGURATION.REMOVE_PLAY_WITH_TOUCHPOINTS_FROM_STATE: {
            return Object.assign({}, state, {
                loadedPlayTouchpointsByPlayId: null
            });

        }
        case MARKETINGPLAYCONFIGURATION.SAVE_TOUCHPOINT_SCHEDULE_MAPPING: {
            return Object.assign({}, state, {
                saveTouchpointScheduleMapping: action.payload
            });
        }
        case MARKETINGPLAYCONFIGURATION.UPDATE_TOUCHPOINT_SCHEDULE_MAPPING: {
            return Object.assign({}, state, {
                updateTouchpointScheduleMapping: action.payload
            });
        }
        case MARKETINGPLAYCONFIGURATION.REMOVE_MARKETING_PLAY_BY_ID: {
            return Object.assign({}, state, {
                removeMarketingPlayById: action.payload
            });
        }
        case MARKETINGPLAYCONFIGURATION.GET_ALL_PLAY_TOUCHPOINTS_REVENUE_MAPPINGS_BY_ClIENTID: {
            return Object.assign({}, state, {
                allPlayTouchPointRevenueMappings: action.payload
            });
        }
        case MARKETINGPLAYCONFIGURATION.GET_MAPPED_SCHEDULE_BY_PLAYID: {
            return Object.assign({}, state, {
                mappedScheduleByPlayId: action.payload
            });
        }

        default:
            return state
    }

}

export default MarketingPlayConfigurationReducer